// extracted by mini-css-extract-plugin
module.exports = {"container":"MobileSearch_container__S_xtZ","inputContainer":"MobileSearch_inputContainer__buf7I","cancel":"MobileSearch_cancel__trWqY","results":"MobileSearch_results__xtqTM"};